<template>
  <div style="height:100%;width:100%;" id="app">
    <router-view ref="routerView" class="router-content"></router-view>
  </div>
</template>

<script>
import GLOBAL from '../../../components/jiri/Global'
import callapp from 'callapp'
export default {
  beforeMount() {},
  mounted() {
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    // 如果url中指定了跳转画面,跳转至相应页面
    if (GLOBAL.getUrlParam('pageName')) {
      // 如果是分享画面
      if (decodeURI(GLOBAL.getUrlParam('pageName')) == 'Share') {
        location.assign(
          'share.html?choseDate=' + decodeURI(GLOBAL.getUrlParam('choseDate'))
        )
        // 其他画面
      } else {
        location.replace(decodeURI(GLOBAL.getUrlParam('pageName')) + '.html')
      }
      // 如果url中未指定跳转画面,跳转至首页
    } else {
      location.replace('calendar.html')
    }
  },
  data() {
    return {}
  },

  methods: {}
}
</script>

<style>
.router-content {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
